import React, { useEffect, useState, useContext, useRef } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';

function CloneSetupModal({CurrentSetup, finalizeCloneResult}){

    const [buttonDisabled, setButtonDisabled] = useState(false);

    const clickResult = (result) => {
        setButtonDisabled(true);
        finalizeCloneResult(result);
    };

    return(
        <div className='modal-container' style={{height:"200px", maxWidth:"400px"}}>
            <button className='modal-close-button' onClick={() => clickResult(false)}><Cross2Icon width='30px' height='30px'/></button>
            <div className='modal-header'>Clone setup</div>
            <div className='modal-content'>
                <div style={{fontSize:'18px'}}>Do you want to clone the setup?</div>
            </div>
            <div className="modal-footer" >
                <button disabled={buttonDisabled} className="button" style={{width:'100px'}} onClick={() => clickResult(true)}>Yes</button>
            </div>
        </div>
            );
}

export default CloneSetupModal;